import { useEffect, useMemo, useState } from 'react'
import TextInput from '../../../components/TextInput'
import { SMS, Whatsapp } from '../../../assets/svg-icons'
import Button from '../../../components/Button'
import { Call, Mail } from 'react-huge-icons/solid'
import { useTranslation } from 'react-i18next'
import { useSession } from 'src/features/auth'
import { z } from 'zod'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'

const validator = z.object({
    username: z.string().trim().min(10).max(10).refine(val => !isNaN(Number(val))).or(z.string().email())
})

type SignInFormInput = z.infer<typeof validator>;


const PhoneNumberForm = ({ }) => {

    const IconC = Call
    const { t } = useTranslation();

    const { handleSubmit, formState: { isSubmitting }, register } = useForm<SignInFormInput>({
        resolver: zodResolver(validator),
        defaultValues: {
            username: ""
        }
    });

    const onSubmit = async (input: SignInFormInput) => {
        if (z.string().email().safeParse(input.username).success) {
            // send to email
            alert("Send OTP To email doesnt set yet.")
        }
        else {
            await signIn(`+972${input.username}`)
        }

    }

    const { signIn } = useSession();

    return (
        <form className='flex flex-col items-center justify-center gap-6' onSubmit={handleSubmit(onSubmit)}>

            <div className=' w-full'>
                <TextInput inputProps={{ ...register("username") }} icon={() => <IconC fontSize={24} className='text-dark' />} px={16} label={t('phone')} placeholder={t("your_phone")} />
            </div>

            <hr className='w-full border-[#EFEFEF]' />

            <div className='flex w-full pt-4'>
                <Button loading={isSubmitting} disabled={isSubmitting} type="submit">
                    {t("signin_submit")}
                </Button>
            </div>
        </form>
    )
}

export default PhoneNumberForm